import { useLanguage } from "@/context/LanguageContext";
import { Award, Users, ShieldCheck, BookOpen, Globe } from "lucide-react";

const DOCTOR_IMG_1 = "https://customer-assets.emergentagent.com/job_dr-burcu-portal/artifacts/zfxcb01u_dsasdwwq.jpg";
const DOCTOR_IMG_2 = "https://customer-assets.emergentagent.com/job_dr-burcu-portal/artifacts/feh6ks01_sadwq.jpg";

export default function AboutPage() {
  const { t } = useLanguage();

  const highlights = [
    { icon: Award, label: t("about.stats.experience"), sub: t("about.stats.experience_label") },
    { icon: Users, label: t("about.stats.patients"), sub: t("about.stats.patients_label") },
    { icon: ShieldCheck, label: t("about.stats.certifications"), sub: t("about.stats.certifications_label") },
  ];

  return (
    <div className="min-h-screen pt-20">
      <section className="py-20 bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center space-y-4">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4A6753]">{t("about.overline")}</span>
          <h1 data-testid="about-page-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-[#1E2922] font-semibold">
            {t("about.title")}
          </h1>
        </div>
      </section>

      <section className="py-24 bg-[#FDFBF7]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-16 items-start">
            <div className="md:col-span-5">
              <div className="relative sticky top-28">
                <div className="absolute -inset-3 bg-[#C9A988]/15 rounded-3xl blur-xl" />
                <img src={DOCTOR_IMG_1} alt="Dr. Burcu Varol" data-testid="about-doctor-image" className="relative w-full rounded-2xl shadow-lg object-cover aspect-[3/4]" />
              </div>
            </div>
            <div className="md:col-span-7 space-y-6">
              <p data-testid="about-bio-1" className="text-base leading-relaxed text-[#566D60]">{t("about.bio_p1")}</p>
              <p data-testid="about-bio-2" className="text-base leading-relaxed text-[#566D60]">{t("about.bio_p2")}</p>
              <p data-testid="about-bio-3" className="text-base leading-relaxed text-[#566D60]">{t("about.bio_p3")}</p>
              <div className="grid grid-cols-3 gap-6 pt-8">
                {highlights.map((item, i) => (
                  <div key={i} data-testid={`about-highlight-${i}`} className="text-center bg-[#F4F1EA] rounded-2xl p-6">
                    <item.icon className="mx-auto text-[#4A6753] mb-3" size={28} strokeWidth={1.5} />
                    <div className="text-2xl font-heading font-semibold text-[#1E2922]">{item.label}</div>
                    <div className="text-xs text-[#566D60] mt-1">{item.sub}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#F4F1EA]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-16 items-center">
            <div className="md:col-span-7 space-y-6">
              <div className="flex items-center gap-4">
                <BookOpen size={24} className="text-[#4A6753]" strokeWidth={1.5} />
                <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4A6753]">{t("about.overline")}</span>
              </div>
              <h2 className="font-heading text-2xl sm:text-3xl tracking-tight text-[#1E2922] leading-relaxed">
                {t("about.bio_p2")}
              </h2>
              <div className="flex items-center gap-6 pt-4">
                <div className="flex items-center gap-2 text-[#566D60]">
                  <ShieldCheck size={18} className="text-[#4A6753]" />
                  <span className="text-sm">Board Certified</span>
                </div>
                <div className="flex items-center gap-2 text-[#566D60]">
                  <Globe size={18} className="text-[#4A6753]" />
                  <span className="text-sm">International Experience</span>
                </div>
              </div>
            </div>
            <div className="md:col-span-5">
              <img src={DOCTOR_IMG_2} alt="Dr. Burcu Varol" data-testid="about-secondary-image" className="w-full rounded-2xl shadow-lg object-cover aspect-[4/3]" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
